import { createActionCreator } from "common/ReduxUtils";
import { InboundActionTypes } from "inbounds/store/InboundActionTypes";
import { Dictionary } from "lodash";
import { ShippingPlanItemLotExpirationRaw } from "@deliverr/inbound-client";

export const setLotTracking = createActionCreator<Dictionary<ShippingPlanItemLotExpirationRaw>>(
  InboundActionTypes.SET_LOT_TRACKING,
  "lotTracking"
);
